export function bindActions(rawActions) {
    return function (view) {
        return Object.entries(rawActions).reduce((acc, [key, spec]) => {
            acc[key] = {
                isActive: () => { var _a, _b; return (_b = (_a = spec.isActive) === null || _a === void 0 ? void 0 : _a.call(spec, view.state)) !== null && _b !== void 0 ? _b : false; },
                isEnable: (arg) => spec.isEnable(view.state, undefined, view, arg),
                run: (arg) => spec.run(view.state, view.dispatch, view, arg),
                meta: () => { var _a; return (_a = spec.meta) === null || _a === void 0 ? void 0 : _a.call(spec, view.state); },
            };
            return acc;
        }, {});
    };
}
